import Vue from 'vue'
import 'normalize.css'
import './styles/index.styl'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLuckyCanvas from '@lucky-canvas/vue'

import '@/utils'
// 全局公共组件
import '@/components'
import './assets/font/font.css'

import funcDialog from '@/components/func-dialog/index'
Vue.prototype.$funcDialog = funcDialog;

Vue.config.productionTip = false

Vue.prototype.bus = new Vue()

Vue.use(VueLuckyCanvas)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
